import VVSTable from "components/form-control/VVSTable";
import React from "react";
import { Container, Row, Col } from "reactstrap";

export default function Order() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <VVSTable title={"Đơn Hàng"} name="Order" disableAdd disableDelete />
        </Container>
      </div>
    </React.Fragment>
  );
}
